import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class RequestDebounceConfigService {
  private debounceTimeMs = 1000;
  private skipMethods = ["POST", "PUT", "PATCH", "DELETE"];
  private skipUrls: string[] = [];

  getDebounceTime(): number {
    return this.debounceTimeMs;
  }

  setDebounceTime(timeMs: number): void {
    if (timeMs > 0) {
      this.debounceTimeMs = timeMs;
    }
  }

  getSkipMethods(): string[] {
    return [...this.skipMethods];
  }

  addSkipMethod(method: string): void {
    const upperMethod = method.toUpperCase();
    if (!this.skipMethods.includes(upperMethod)) {
      this.skipMethods.push(upperMethod);
    }
  }

  removeSkipMethod(method: string): void {
    const upperMethod = method.toUpperCase();
    this.skipMethods = this.skipMethods.filter(m => m !== upperMethod);
  }

  getSkipUrls(): string[] {
    return [...this.skipUrls];
  }

  addSkipUrl(url: string): void {
    if (!this.skipUrls.includes(url)) {
      this.skipUrls.push(url);
    }
  }

  removeSkipUrl(url: string): void {
    this.skipUrls = this.skipUrls.filter(u => u !== url);
  }

  shouldSkipUrl(url: string): boolean {
    return this.skipUrls.some(skipUrl => url.includes(skipUrl));
  }
}
